import { Status, TypeOfLoan } from '__generated__/api';
import { ApplicantDetails, LoanDetailsFormType, LoanPartType, ToggleType } from '../../types';
import { ClientDetailsLoanParts } from 'types/ClientDetails/ClientDetailsLoanParts';
import { ClientDetailsModel } from 'types/ClientDetails/ClientDetailsModel';
import { ClientDetailsPerson } from 'types/ClientDetails/ClientDetailsPerson';
import { ClientExtractLoanPartGuaranteeEnum } from 'types/ClientDetails/Enums/ClientExtractLoanPartGuaranteeEnum';

const mapGuarantee = (
  value: ClientExtractLoanPartGuaranteeEnum | undefined
): ToggleType | undefined => {
  if (
    value === ClientExtractLoanPartGuaranteeEnum.NHG ||
    value === ClientExtractLoanPartGuaranteeEnum.Communal
  ) {
    return 'yes';
  }
  if (
    value === ClientExtractLoanPartGuaranteeEnum.Na ||
    value === ClientExtractLoanPartGuaranteeEnum.VAT
  ) {
    return 'no';
  }
  return undefined;
};

const mapLoanParts = (loanParts: ClientDetailsLoanParts[] = []): LoanPartType[] => {
  return loanParts.map((loanPart) => {
    return {
      loanPartNumber: loanPart.number ?? undefined,
      repaymentType: loanPart.product ?? undefined,
      shouldSplitLoan: undefined,
      NHGGuarantee: mapGuarantee(loanPart.guarantee),
      loanAmount: loanPart.residualDebt ?? undefined,
      hasConnectedPolicy: undefined,
      convertLoan: undefined,
      splitLoan: undefined,
      numberOfSplitLoanParts: undefined,
    };
  });
};

const mapApplicants = (persons: ClientDetailsPerson[] | undefined): ApplicantDetails[] | [] => {
  if (!persons) return [];
  return persons?.map((person) => ({
    initials: person?.natural?.name?.initials,
    lastName: person?.natural?.name?.lastName,
    middleName: '',
  }));
};

export const mapClientData = (
  clientData: ClientDetailsModel,
  commercialLabel: string
): LoanDetailsFormType => {
  const { loan, loanParts, persons } = clientData;
  return {
    conversionQuestionnaire: {
      residualDebt: loan?.residualDebt ?? undefined,
      loanNumber: loan?.number ?? 0,
      toggleInterest: undefined,
      toggleCoFinancedFine: undefined,
      toggleFine: undefined,
    },
    loanParts: mapLoanParts(loanParts),
    status: Status.New,
    typeOfLoan: TypeOfLoan.Conversion,
    commercialLabel: commercialLabel,
    moneylenderName: '',
    id: 0,
    applicants: mapApplicants(persons),
  };
};
export default mapClientData;
